import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CatalogProduct } from '../types';

export interface CartItem {
  prodotto_id: string;
  prodotto: CatalogProduct;
  quantita: number;
  note?: string;
}

interface CartState {
  items: CartItem[];
  addItem: (product: CatalogProduct, quantita?: number) => void;
  removeItem: (prodotto_id: string) => void;
  updateQuantity: (prodotto_id: string, quantita: number) => void;
  updateNote: (prodotto_id: string, note: string) => void;
  clearCart: () => void;
  getItemCount: () => number;
  getTotale: () => number;
}

export const useCartStore = create<CartState>()(
  persist(
    (set, get) => ({
      items: [],

      addItem: (product, quantita = 1) => {
        set((state) => {
          const existing = state.items.find((i) => i.prodotto_id === product.id);
          if (existing) {
            return {
              items: state.items.map((i) =>
                i.prodotto_id === product.id
                  ? { ...i, quantita: i.quantita + quantita }
                  : i
              ),
            };
          }
          return {
            items: [
              ...state.items,
              { prodotto_id: product.id, prodotto: product, quantita, note: undefined },
            ],
          };
        });
      },

      removeItem: (prodotto_id) => {
        set((state) => ({
          items: state.items.filter((i) => i.prodotto_id !== prodotto_id),
        }));
      },

      updateQuantity: (prodotto_id, quantita) => {
        if (quantita < 1) return;
        set((state) => ({
          items: state.items.map((i) =>
            i.prodotto_id === prodotto_id ? { ...i, quantita } : i
          ),
        }));
      },

      updateNote: (prodotto_id, note) => {
        set((state) => ({
          items: state.items.map((i) =>
            i.prodotto_id === prodotto_id ? { ...i, note: note || undefined } : i
          ),
        }));
      },

      clearCart: () => set({ items: [] }),

      getItemCount: () => {
        return get().items.reduce((sum, i) => sum + i.quantita, 0);
      },

      getTotale: () => {
        return get().items.reduce((sum, i) => {
          const prezzo = i.prodotto.prezzo_finale ?? i.prodotto.prezzo_unitario ?? 0;
          return sum + prezzo * i.quantita;
        }, 0);
      },
    }),
    {
      name: 'offertify-cart',
    }
  )
);
